import React, { useEffect, useMemo } from "react";
import AutoriaMainLayout from "../components/services/autoria/AutoriaMainLayout";
import {
  NavLink,
  Route,
  Switch,
  useRouteMatch,
  useHistory,
  Redirect,
} from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import "../scss/autoria.scss";
import { PageHeader } from "../components/PageHeader";
import { useTranslation } from "react-i18next";
function Services() {
  const { path } = useRouteMatch();
  const { t } = useTranslation();
  const tabs = [
    {
      id: 1,
      path: `/services/autorship-proof`,
      label: t("services.copyright.header"),
    },
  ];

  return (
    <MainLayout className="">
      <div className="services--main--container">
        {/* <div className="services--header">
          <h2>Servicios</h2>
          <div className="NavBar--services">
            <NavLink
              to="/services/autorship-proof"
              className="NavLink--services"
              activeClassName="NavLink--services--active"
            >
              Constancia Digital de Autoria
            </NavLink>
          </div>
        </div> */}
        <PageHeader className="bg-white pb-0 pt-4">
          <PageHeader.Title>{t("services.header")}</PageHeader.Title>
          <PageHeader.Tabs tabs={tabs} />
        </PageHeader>
        <Switch>
          <Route path={`${path}/autorship-proof`}>
            <AutoriaMainLayout />
          </Route>
          <Redirect from={path} to={`${path}/autorship-proof`} />
        </Switch>
      </div>
    </MainLayout>
  );
}

export default Services;
